/**
 * ========================================
 * USE TOAST HOOK
 * ========================================
 * Centralized toast notification management
 */

import { useContext } from 'react';
import { ToastContext, ToastContextType } from '@context/ToastContext';

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);
  
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }

  return context;
};
